import React from "react";
//#region components
import { TitledContainerInner } from "components/common";
import ClassifiedReceiptContainer from "components/receipt/forms/classifiedReceiptContainer";
//#endregion
//#region types
import { ClassifiedReceiptMainSectionProps } from "models/propTypes/receiptPropTypes";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import { TranslationKeys } from "translations";

const ClassifiedReceiptMainSection: React.FC<ClassifiedReceiptMainSectionProps> = ({
  classifiedReceipt,
  formRef,
}) => {
  return (
    <TitledContainerInner
      header={LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.Receipt.ClassifiedReceiptTodoHeaderText
      )}
      subHeader={LocalizationHelperInstance.getFormattedMessage(
        TranslationKeys.Receipt.ClassifiedReceiptTodoSubHeaderText
      )}
    >
      <ClassifiedReceiptContainer
        ref={formRef}
        classifiedReceipt={classifiedReceipt}
      />
    </TitledContainerInner>
  );
};

export default ClassifiedReceiptMainSection;
